import React from 'react';
import * as Styled from './style';

// Íconos
import Icon1 from '../../assets/images/Ai.png';
import Icon2 from '../../assets/images/Question.png';
import Icon3 from '../../assets/images/LegalIntake.png';
import Icon4 from '../../assets/images/Customize.png';
import Icon5 from '../../assets/images/Schedule.png';
import Icon6 from '../../assets/images/Headset.png';

const items = [
  {
    icon: Icon1,
    title: 'AI-powered experience',
    description:
      'AI technology allows our webchat to simulate a human interaction in order to provide rapid responses to your leads’ needs.',
  },
  {
    icon: Icon2,
    title: 'Custom training protocols',
    description:
      'Our AI chatbot will be able to answer any questions web leads may have about your business so they can better understand how you will solve their problem.',
  },
  {
    icon: Icon3,
    title: (
      <>
        Full intake <br /> process
      </>
    ),
    description:
      'Whatever information you need from your leads, our chatbot will prompt them for it conversationally and send it to you for your follow-up.',
  },
  {
    icon: Icon4,
    title: 'Branding and customization',
    description:
      'During the setup process, we’ll give our AI chatbot a look unique to your business, complete with your logo, color scheme, and other branding elements.',
  },
  {
    icon: Icon5,
    title: 'Calendar integration',
    description:
      'At the end of every intake, web leads will be prompted to schedule a consultation according to your availability.',
  },
  {
    icon: Icon6,
    title: (
      <>
        Setup and <br /> support
      </>
    ),
    description:
      'Our white-glove support team will help you establish our chatbot on your website and customize it for your needs.',
  },
];

export default function IntakeSolutionsSection() {
  return (
    <Styled.Section>
      <Styled.Heading>
        State-of-the-art intake solutions for home service businesses
      </Styled.Heading>

      <Styled.ScrollHint>{`>> Scroll to view features >>>`}</Styled.ScrollHint>

      <Styled.Grid>
        {items.map((item, i) => (
          <Styled.Card key={i}>
            <img src={item.icon} alt='' />
            <div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </Styled.Card>
        ))}
      </Styled.Grid>
    </Styled.Section>
  );
}
